module.exports = __webpack_public_path__ + "img/reactions.846a5bcd.svg";